<template>
<div class="homePage" id="productArea">
  <!-- 至頂圖片區 開始 -->
  <div class="product-area">
    <Row type="flex" justify="center" class="product-area-blocks">
      <!-- <Col :xs="24" :sm="24" :md="16" :lg="16" v-for="(item) in productList" :key="item.name">
        <div :class="['left', 'block', item.name === 'block01' && 'block--first']">
          <img :class="[item.name === 'block01' ? 'block-img--first' : 'block-img']" :src="item.img"/>
          <div class="block-btn" @click="switchPage(item.path)">{{ $t( item.btn ) }}</div>
        </div>
      </Col> -->
      <Col :xs="24" :sm="24" :md="8" :lg="8" v-for="item in bannerList" :key="item.name">
        <div class="block left">
          <img class="block-img" :src="item.img"/>
        </div>
      </Col>
      <!-- <Col :xs="24" :sm="24" :md="8" :lg="8">
        <div class="blocks">
          <Carousel autoplay v-model="value" arrow="always">
            <Carousel-item v-for="item in bannerList" :key="item.name">
              <div class="block">
                <img class="block-img" :src="item.img"/>
              </div>
            </Carousel-item>
          </Carousel>
        </div>
      </Col> -->
      <!-- 右側輪播圖 結束 -->
    </Row>
  </div>
  <!-- 至頂圖片區 結束 -->
  <!-- 介紹萬達區 開始 -->
  <Row>
    <Col span="24" id="aboutArea">
      <div class="about-area">
        <!-- <div class="block">
          <img class="block-img" :src="block04"/>
        </div> -->
        <div class="info">
          <div class="area-main-title">{{ $t('aboutTitle1') }}&emsp;<span class="color-word">{{ $t('aboutTitle2') }}</span></div>
          <img class="area-logo" :src="logo"/>
          <div class="area-sub-title color-word">{{ $t('aboutSubtitle') }}</div>
          <div class="area-content">{{ $t('aboutContent', { point: '\'' }) }}</div>
        </div>
        <div class="block-btn" ref="aboutBtn" @click="openMorePage()">{{ $t('readMore') }}</div>
      </div>
    </Col>
  </Row>
  <transition name="aboutMore">
    <div class="about-area-more" v-show="morePage">
      <div class="info">
        <Row>
          <Col span="24">
            <div class="area-sub-title color-word">{{ $t('cultureTitle') }}</div>
          </Col>
        </Row>
        <div class="area-block">
          <Row>
            <Col  :xs="24" :sm="24" :md="12" :lg="12">
              <div class="area-block-inner">
                <img class="icon" :src="iconFaith"/>
                <div class="area-small-title"><div>{{ $t('cultureSubtitle1') }}</div></div>
                <div class="area-content">{{ $t('cultureContent1') }}</div>
              </div>
            </Col>
            <Col :xs="24" :sm="24" :md="12" :lg="12">
              <div class="area-block-inner">
                <img class="icon" :src="iconBulb"/>
                <div class="area-small-title">{{ $t('cultureSubtitle3') }}</div>
                <div class="area-content">{{ $t('cultureContent3') }}</div>
              </div>
            </Col>
            <Col :xs="24" :sm="24" :md="12" :lg="12">
              <div class="area-block-inner">
                <img class="icon" :src="iconTeam"/>
                <div class="area-small-title">{{ $t('cultureSubtitle2') }}</div>
                <div class="area-content">{{ $t('cultureContent2') }}</div>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  </transition>
  <!-- 介紹萬達區 結束 -->
  <!-- 開發過程區 開始 -->
  <div class="dev-area" id="devArea">
    <Row type="flex">
      <Col span="24">
        <div class="area-main-title">{{ $t('devMainTitle') }}</div>
      </Col>
    </Row>
    <Row class="info">
      <Col :xs="24" :sm="24" :md="6" :lg="6" v-for="item in devInfoList" :key="item.name">
        <div class="block slide-in" ref="block">
          <div class="area-sub-title color-word">{{ $t( item.subTitle ) }}</div>
          <div class="area-content">{{ $t( item.content ) }}</div>
          <img class="block-img" :src="item.img"/>
        </div>
      </Col>
    </Row>
  </div>
  <!-- 開發過程區 結束 -->
  <!-- 技術支援區 開始 -->
  <div class="tech-area" id="techArea">
    <Row type="flex">
      <Col span="24">
        <div class="area-main-title">{{ $t('tectMainTitle') }}</div>
      </Col>
    </Row>
    <Row class="info">
      <Col :xs="24" :sm="24" :md="8" :lg="8" v-for="item in techInfoList" :key="item.name">
        <div class="block slide-in-same">
          <img class="block-img" :src="item.img"/>
          <div class="area-sub-title">{{ $t( item.subTitle ) }}</div>
        </div>
      </Col>
    </Row>
    <div class="block-btn" @click="isModalOpen = true">{{ $t('contactus') }}</div>
  </div>
  <!-- 技術支援區 結束 -->
  <Modal
      v-model="isModalOpen"
      width="400"
      :title="$t('contactus')">
      <div class="icon-email" ><img :src="iconEmail"/></div>
      <p class="email">{{ email }}</p>
      <div slot="footer" class="modal-footer">
        <div class="copy-btn" ref="copyBtn" v-clipboard:copy="email" @click="copy()">{{ $t('copy')}}</div>
      </div>
  </Modal>
</div>
</template>

<script>
/* PC版 */
// 英文
// import block01en from '@/assets/common/homePage/hm_block01_en.jpg'
import block01en from '@/assets/common/homePage/hm_block01_02_en.png'
// import block02en from '@/assets/common/homePage/hm_block02_en.jpg'
// import block0301en from '@/assets/common/homePage/hm_block03_01_en.png'
import block0302en from '@/assets/common/homePage/hm_block03_02_en.png'
import block0303en from '@/assets/common/homePage/hm_block03_03_en.png'
import block0304en from '@/assets/common/homePage/hm_block03_04_en.png'
// 簡體中文
// import block01cn from '@/assets/common/homePage/hm_block01_sc.jpg'
// import block02cn from '@/assets/common/homePage/hm_block02_sc.jpg'
// import block0301cn from '@/assets/common/homePage/hm_block03_01_sc.png'
import block0302cn from '@/assets/common/homePage/hm_block03_02_sc.png'
import block0303cn from '@/assets/common/homePage/hm_block03_03_sc.png'
// 繁體中文
// import block01tw from '@/assets/common/homePage/hm_block01_tc.jpg'
// import block02tw from '@/assets/common/homePage/hm_block02_tc.jpg'
// import block0301tw from '@/assets/common/homePage/hm_block03_01_tc.png'
import block0302tw from '@/assets/common/homePage/hm_block03_02_tc.png'
import block0303tw from '@/assets/common/homePage/hm_block03_03_tc.png'
import block0304tw from '@/assets/common/homePage/hm_block03_04_tc.png'
// 通用
import logo from '@/assets/platformConfig/logo_golden_river_01.png'
import iconBulb from '@/assets/common/homePage/icon/icon_bulb_01.png'
import iconFaith from '@/assets/common/homePage/icon/icon_faith_01.png'
import iconTeam from '@/assets/common/homePage/icon/icon_team_01.png'
import process01 from '@/assets/common/homePage/img_process_01.png'
import process02 from '@/assets/common/homePage/img_process_02.png'
import process03 from '@/assets/common/homePage/img_process_03.png'
import process04 from '@/assets/common/homePage/img_process_04.png'
import iconGuide from '@/assets/common/homePage/icon/icon_guide_01.png'
import iconRigthts from '@/assets/common/homePage/icon/icon_rights_01.png'
import iconTech from '@/assets/common/homePage/icon/icon_tech_01.png'
// Modal
import iconEmail from '@/assets/common/homePage/icon/img_email_01.png'
/* 手機版 */
import mbProcess01 from '@/assets/mobile/homePage/icon/mb_img_process_01.png'
import mbProcess02 from '@/assets/mobile/homePage/icon/mb_img_process_02.png'
import mbProcess03 from '@/assets/mobile/homePage/icon/mb_img_process_03.png'
import mbProcess04 from '@/assets/mobile/homePage/icon/mb_img_process_04.png'
// 英文
import companyImg01en from '@/assets/mobile/homePage/mb_img_company_01_en.jpg'
// import mbBlock01en from '@/assets/mobile/homePage/mb_hm_block01_en.jpg'
// import mbBlock02en from '@/assets/mobile/homePage/mb_hm_block02_en.jpg'
// import mbBlock0301en from '@/assets/mobile/homePage/banner/mb_hm_block03_01_en.png'
import mbBlock0302en from '@/assets/mobile/homePage/banner/mb_hm_block03_02_en.jpg'
import mbBlock0303en from '@/assets/mobile/homePage/banner/mb_hm_block03_03_en.png'
import mbBlock0304en from '@/assets/mobile/homePage/banner/mb_hm_block03_04_en.png'
// 簡體中文
import companyImg01cn from '@/assets/mobile/homePage/mb_img_company_01_sc.jpg'
// import mbBlock01cn from '@/assets/mobile/homePage/mb_hm_block01_sc.jpg'
// import mbBlock02cn from '@/assets/mobile/homePage/mb_hm_block02_sc.jpg'
// import mbBlock0301cn from '@/assets/mobile/homePage/banner/mb_hm_block03_01_sc.png'
import mbBlock0302cn from '@/assets/mobile/homePage/banner/mb_hm_block03_02_sc.jpg'
import mbBlock0303cn from '@/assets/mobile/homePage/banner/mb_hm_block03_03_sc.png'
// 繁體中文
import companyImg01tw from '@/assets/mobile/homePage/mb_img_company_01_tc.jpg'
// import mbBlock01tw from '@/assets/mobile/homePage/mb_hm_block01_tc.jpg'
// import mbBlock02tw from '@/assets/mobile/homePage/mb_hm_block02_tc.jpg'
// import mbBlock0301tw from '@/assets/mobile/homePage/banner/mb_hm_block03_01_tc.png'
import mbBlock0302tw from '@/assets/mobile/homePage/banner/mb_hm_block03_02_tc.jpg'
import mbBlock0303tw from '@/assets/mobile/homePage/banner/mb_hm_block03_03_tc.png'
import mbBlock0304tw from '@/assets/mobile/homePage/banner/mb_hm_block03_04_tc.png'
export default {
  data () {
    return {
      block04: '',
      companyImg01en,
      companyImg01cn,
      companyImg01tw,
      logo,
      value: 0,
      iconBulb,
      iconFaith,
      iconTeam,
      iconEmail,
      morePage: false,
      search: {
        number: ''
      },
      // isLoading: false,
      isModalOpen: false,
      email: 'Contact@goldenriver.tech',
      bannerList: [
        {
          name: 'block0303',
          img: '',
          pc: {
            en: block0303en,
            cn: block0303cn,
            tw: block0303tw
          },
          mb: {
            en: mbBlock0303en,
            cn: mbBlock0303cn,
            tw: mbBlock0303tw
          }
        },
        {
          name: 'block0304',
          img: '',
          pc: {
            en: block0304en,
            // cn: block0304cn,
            tw: block0304tw
          },
          mb: {
            en: mbBlock0304en,
            // cn: mbBlock0301cn,
            tw: mbBlock0304tw
          }
        },
        {
          name: 'block0302',
          img: '',
          pc: {
            en: block0302en,
            cn: block0302cn,
            tw: block0302tw
          },
          mb: {
            en: mbBlock0302en,
            cn: mbBlock0302cn,
            tw: mbBlock0302tw
          }
        }
        // {
        //   name: 'block0301',
        //   img: '',
        //   pc: {
        //     en: block0301en,
        //     cn: block0301cn,
        //     tw: block0301tw
        //   },
        //   mb: {
        //     en: mbBlock0301en,
        //     cn: mbBlock0301cn,
        //     tw: mbBlock0301tw
        //   }
        // },
      ],
      productList: [
        {
          name: 'block01',
          img: '',
          pc: {
            en: block01en,
            cn: block01en,
            tw: block01en
          },
          mb: {
            en: block01en,
            cn: block01en,
            tw: block01en
          },
          path: '/trade',
          btn: 'more'
        }
        // {
        //   name: 'block02',
        //   img: '',
        //   pc: {
        //     en: block02en,
        //     cn: block02cn,
        //     tw: block02tw
        //   },
        //   mb: {
        //     en: mbBlock02en,
        //     cn: mbBlock02cn,
        //     tw: mbBlock02tw
        //   },
        //   path: '/wallet',
        //   btn: 'more'
        // }
      ],
      devInfoList: [
        {
          name: 'process01',
          subTitle: 'devSubTitle1',
          content: 'devSubContent1',
          img: '',
          pc: {
            common: process01
          },
          mb: {
            common: mbProcess01
          }
        },
        {
          name: 'process02',
          subTitle: 'devSubTitle2',
          content: 'devSubContent2',
          img: '',
          pc: {
            common: process02
          },
          mb: {
            common: mbProcess02
          }
        },
        {
          name: 'process03',
          subTitle: 'devSubTitle3',
          content: 'devSubContent3',
          img: '',
          pc: {
            common: process03
          },
          mb: {
            common: mbProcess03
          }
        },
        {
          name: 'process04',
          subTitle: 'devSubTitle4',
          content: 'devSubContent4',
          img: '',
          pc: {
            common: process04
          },
          mb: {
            common: mbProcess04
          }
        }
      ],
      techInfoList: [
        {
          name: 'techIcon1',
          subTitle: 'techIcon1',
          img: iconTech
        },
        {
          name: 'techIcon2',
          subTitle: 'techIcon2',
          img: iconGuide
        },
        {
          name: 'techIcon3',
          subTitle: 'techIcon3',
          img: iconRigthts
        }
      ]
    }
  },
  methods: {
    switchPage (path) {
      // console.log(this.$route.query.id)
      this.$router.push(path)
    },
    openMorePage () {
      this.morePage = !this.morePage
      const btn = this.$refs.aboutBtn
      btn.classList.add('activeBtn')
      if (this.morePage === false) {
        btn.classList.remove('activeBtn')
      }
    },
    copy () {
      const element = this.$refs.copyBtn
      element.classList.add('activeBtn')
    },
    // --------------------------------------圖片動畫區 開始----------------------------------------------
    debounce (func, wait = 20, immediate = true) {
      var timeout
      return function () {
        var context = this
        var args = arguments
        var later = function () {
          timeout = null
          if (!immediate) func.apply(context, args)
        }
        var callNow = immediate && !timeout
        clearTimeout(timeout)
        timeout = setTimeout(later, wait)
        if (callNow) func.apply(context, args)
      }
    },
    scrollhandler () {
      if (!this.isPhone) { // PC版才有動畫
        const windowTop = window.scrollY
        const windowBototm = windowTop + window.innerHeight
        const imgs = document.querySelectorAll('div.slide-in-same') // 技術支援區 3個icon
        for (let j = 0; j < imgs.length; j++) {
          const imgsOffsetTop = imgs[j].offsetParent.offsetParent.offsetTop
          if (imgsOffsetTop < windowBototm && imgsOffsetTop + imgs[j].offsetHeight / 2 > windowTop) {
            imgs[j].classList.add('active') // 同時進場
          } else { // 否則就讓圖片退場
            imgs[j].classList.remove('active')
          }
        }
        const divs = document.querySelectorAll('div.slide-in') // 開發過程區 4張圖
        for (let i = 0; i < divs.length; i++) {
          const divsOffsetTop = divs[i].offsetParent.offsetParent.offsetTop
          if (divsOffsetTop < windowBototm && divsOffsetTop + divs[i].offsetHeight / 2 > windowTop) {
            setTimeout(() => {
              divs[i].classList.add('active')
            }, (i + 1) * 200) // 每張圖片間隔0.2s出場
          } else { // 否則就讓圖片退場
            setTimeout(() => {
              divs[i].classList.remove('active')
            }, (i + 1) * 200)
          }
        }
      }
    },
    // --------------------------------------圖片動畫區 結束----------------------------------------------
    // ---------------------------------------Handler區 開始--------------------------------------------------
    bannerHandler () {
      if (this.isPhone) {
        const mblocale = this.$store.state.login.locale ? this.$store.state.login.locale : 'en'
        // const locale = sessionStorage.getItem('locale')
        this.imgHandler(this.devInfoList, 'mb', 'common')
        // 以下如果手機板解析度可以,就全部刪除
        switch (mblocale) {
          case 'en':
            this.imgHandler(this.productList, 'mb', 'en')
            this.imgHandler(this.bannerList, 'mb', 'en')
            this.block04 = this.companyImg01en
            break
          case 'tw':
            this.imgHandler(this.productList, 'mb', 'tw')
            this.imgHandler(this.bannerList, 'mb', 'tw')
            this.block04 = this.companyImg01tw
            break
          case 'cn':
            this.imgHandler(this.productList, 'mb', 'cn')
            this.imgHandler(this.bannerList, 'mb', 'cn')
            this.block04 = this.companyImg01cn
            break
        }
      } else {
        const locale = this.$store.state.login.locale ? this.$store.state.login.locale : 'en'
        // const locale = sessionStorage.getItem('locale')
        this.imgHandler(this.devInfoList, 'pc', 'common')
        switch (locale) {
          case 'en':
            this.imgHandler(this.productList, 'pc', 'en')
            this.imgHandler(this.bannerList, 'pc', 'en')
            this.block0304 = this.block0304en
            this.block0302 = this.block0302en
            this.block0303 = this.block0303en
            break
          case 'tw':
            this.imgHandler(this.productList, 'pc', 'tw')
            this.imgHandler(this.bannerList, 'pc', 'tw')
            break
          case 'cn':
            this.imgHandler(this.productList, 'pc', 'cn')
            this.imgHandler(this.bannerList, 'pc', 'cn')
            break
        }
      }
    },
    imgHandler (list, type, lang) {
      list.forEach((element) => {
        element.img = element[type][lang]
      })
    }
    // ---------------------------------------Handler區 結束--------------------------------------------------
  },
  mounted () {
    this.bannerHandler()
    window.addEventListener('scroll', this.debounce(this.scrollhandler, 50))
  },
  created () {
    this.bannerHandler()
  },
  computed: {
    isPhone () {
      return navigator.userAgent.includes('Mobile')
    }
  }
}
</script>

<style lang="scss">
// *--------------------------PC版 開始--------------------------
.homePage {
  color: #f1f1f1;
  .block{
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 30%;
    &--first {
      height: 100%;
    }
    .block-btn {
      position: absolute;
      padding: 15px 85px; // 改%
      border-radius: 6px;
      top: 85%;
    }
    .block-img {
      width: 100%;
      object-fit: contain;
    }
    .block-img--first {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .product-area-blocks {
    background-color: #0f1d37;
    .blocks {
      font-size: 0px; // 消除inline-block裡面預設的換行所造成的空白
    }
  }
  .about-area {
    background-image: url('~@/assets/common/homePage/img_bg_company_01.jpg');
    background-repeat: no-repeat;
    background-position: left top;
    background-size: cover;
    padding: 50px 90px ;
    .info {
      display: flex;
      flex-direction: column;
      .area-main-title {
        font-size: 30px;
        letter-spacing: 2px;
      }
      .area-logo {
        width: 10%;
        margin: 50px 0px;
      }
      .area-sub-title {
        font-size: 20px;
        letter-spacing: 1px;
        margin-bottom: 15px;
      }
      .area-content {
        width: 35%;
        text-align: justify;
      }
    }
    .block-btn {
      display: inline-block;
      padding: 15px 70px;
      border-radius: 6px;
      margin: 40px 0px 20px;
    }
  }
  .about-area-more {
    background-image: url('~@/assets/common/homePage/img_bg_company_02.png');
    background-repeat: no-repeat;
    background-position: right top;
    background-size: cover;
    color: #f1f1f1;
    padding: 40px 90px ;
    .info {
      .area-sub-title {
        font-size: 20px;
        letter-spacing: 1px;
        margin-bottom: 30px;
      }
      .area-block {
        .area-block-inner {
          display: inline-block;
          width: 100%;
          .area-small-title {
            font-size: 16px;
            margin: 7px 0px;
          }
          .icon {
            width: 90px;
          }
          .area-content {
            width: 70%;
            text-align: justify;
          }
        }
      }
    }
  }
  // 開發過程區 開始
  .dev-area {
    background-color: #1d355b;
    display: flex;
    flex-direction: column;
    align-items: center;
    .area-main-title {
      font-size: 35px;
      font-weight: 500;
      margin: 40px 0px 60px;
    }
    .info {
      width: 75%;
      margin-bottom: 60px;
    }
    .block {
      background-repeat: no-repeat;
      background-size: contain;
      .block-img {
        width: 100%;
        object-fit: contain;
      }
      .area-sub-title {
        position: absolute;
        top: 8%;
        font-size: 18px;
        white-space: nowrap;
      }
      .area-content {
        position: absolute;
        margin-top: 50px;
        font-weight: 300;
        font-size: 13px;
        top: 8%;
        width: 80%;
        text-align: left;
      }
    }
  }
  // 開發過程區 結束
  // 技術支援區 開始
  .tech-area {
    background-color: #1d355b;
    background-image: url('~@/assets/common/homePage/img_wave.png');
    background-position: right bottom;
    background-size: cover;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 20px;
    .area-main-title {
      font-size: 35px;
      font-weight: 500;
      margin: 50px 0px 60px;
    }
    .block {
      // border: solid 1px red;
      margin: 0px 20px;
      .block-img {
        padding: 20px;
      }
      .area-sub-title {
        font-size: 20px;
        white-space: nowrap;
      }
    }
    .block-btn {
      padding: 15px 85px;
      border-radius: 6px;
      margin: 60px 0px 40px;
    }
  }
  // 技術支援區 結束
}
// *--------------------------PC版 結束--------------------------
/* 通用區 */
.color-word {
  color: #fff799;
}
.block-btn {
  cursor: pointer;
  background-color: #0f1e36;
  color: #fff799;
  &:hover {
    background-color: #0960d6;
    color: #f1f1f1;
  }
  &:focus {
    background-color: #003c8e !important;
    color: #fff799 !important;
  }
}
.btnFocus {
  background-color: #003c8e;
  color: #fff799;
}
.area-main-title {
  letter-spacing: 1px;
  font-weight: 700;
}
.area-sub-title, .area-small-title {
  letter-spacing: 1px;
  font-weight: 500;
}
// 開發介紹 輪流跳出
.slide-in, .slide-in-same {
  opacity: 0;
  transition: all .5s;
  transform: translateY(20%) scale(0.95);
}
.slide-in.active, .slide-in-same.active {
  opacity: 1;
  transform: translateY(0%) scale(1);
}
/* RWD設定 開始 */
// 手機版 開始
@media screen  and (max-width: 768px) {
  .homePage {
    .product-area-blocks {
      display: flex;
      flex-direction: column-reverse;
      .block {
        .block-btn {
          width: 90%;
          text-align: center;
          border-radius: 5px;
          // top: 85%;
          top: unset;
          bottom: 5%;
          font-size: 15px;
        }
      }
    }
    .about-area {
      // background-position: left top;
      background-size: 100% 50%;
      background-position: 50% 0%;
      background-color: #1e314f;
      background-image: none;
      // padding: 30px 20px;
      padding: 0px;
      .block {
        .block-img {
          width: 100%;
          object-fit: contain;
        }
      }
      .info {
        padding: 10px 5%;
        .area-main-title {
          display: none;
        }
        .area-logo {
          display: none;
        }
        .area-sub-title {
          font-size: 20px;
          margin-bottom: 10px;
        }
        .area-content {
          width: 100%;
          font-size: 12px;
        }
      }
      .block-btn {
        width: 90%;
        text-align: center;
        border-radius: 6px;
        font-size: 15px;
        margin: 20px 5%;
      }
    }
    .about-area-more {
      padding: 40px 5%;
      .info {
        .area-sub-title {
          font-size: 28px;
          margin-bottom: 30px;
          text-align: center;
        }
        .area-block {
          .area-block-inner {
            display: inline-block;
            width: 100%;
            margin-bottom: 40px;
            .area-small-title {
              font-size: 18px;
              margin: 7px 0px;
            }
            .icon {
              width: 23%;
            }
            .area-content {
              width: 100%;
              font-size: 14px;
            }
          }
        }
      }
    }
    .dev-area {
      background-color: #0b1f3e;
      .area-main-title {
        font-size: 24px;
        margin: 30px 0px 40px;
      }
      .info {
        width: 90%;
        margin-bottom: 0px;
      }
      .block {
        margin-bottom: 50px;
        opacity: 1; // 取消動畫設定
        transform: translateY(0%) scale(1); // 取消動畫設定
        .block-icon {
          width: 12%;
          margin-bottom: 8px;
        }
        .block-img {
          width: 100%;
        }
        .area-sub-title {
          position: relative;
          font-size: 18px;
          white-space: nowrap;
        }
        .area-content {
          position: relative;
          margin-top: 0px; // 必要
          font-size: 14px;
          width: 100%;
          padding: 5px 5%;
          text-align: justify;
        }
      }
    }
    .tech-area {
      background-color: #294572;
      background-image: none;
      padding-top: 20px;
      .area-main-title {
        font-size: 24px;
        letter-spacing: 1px;
        font-weight: 500;
        margin: 20px 0px 20px;
      }
      .info {
        width: 60%;
        .block {
          display: flex;
          flex-direction: row;
          margin: 15px 0px;
          opacity: 1; // 取消動畫設定
          transform: translateY(0%) scale(1); // 取消動畫設定
          .block-img {
            padding: 0px;
            width: 27%;
          }
          .area-sub-title {
            font-size: 14px;
            margin-left: 20px;
            font-weight: 400;
          }
        }
      }
      .block-btn {
        text-align: center;
        width: 90%;
        margin: 40px 0px 40px;
      }
    }
  }
}
// 手機版 結束
@media screen and (min-width: 768px) and (max-width: 992px) { //sm
  .homePage {
    .block {
      .block-btn {
          padding: 8px 55px;
          border-radius: 5px;
          top: 85%;
          font-size: 12px;
      }
    }
    .about-area {
        padding: 30px 40px ;
        .info {
          .area-main-title {
            font-size: 28px;
            letter-spacing: 2px;
          }
          .area-logo {
            width: 70px;
            margin: 20px 0px;
          }
          .area-sub-title {
            font-size: 20px;
            letter-spacing: 1px;
            margin-bottom: 10px;
          }
          .area-content {
            width: 45%;
            font-size: 12px;
          }
        }
        .block-btn {
          padding: 15px 70px;
          border-radius: 6px;
          font-size: 12px;
          margin: 20px 0px;
        }
      }
    .about-area-more {
      background-position: right top;
      padding: 40px 40px ;
      .info {
        .area-sub-title {
          font-size: 20px;
          letter-spacing: 1px;
          margin-bottom: 30px;
        }
        .area-block {
          .area-block-inner {
            display: inline-block;
            width: 90%;
            .area-small-title {
              font-size: 14px;
              margin: 7px 0px;
            }
            .icon {
              width: 60px;
            }
            .area-content {
              width: 100%;
              font-size: 12px;
            }
          }
        }
      }
    }
    .dev-area {
      .area-main-title {
        font-size: 28px;
        font-weight: 500;
        margin: 40px 0px 40px;
      }
      .info {
        width: 85%;
        margin-bottom: 60px;
      }
      .block {
        .block-img {
          width: 120%;
        }
        .area-sub-title {
          top: 8%;
          font-size: 11px;
        }
        .area-content {
          font-size: 7px;
          line-height: 13px;
          margin-top: 20px;
          top: 8%;
          width: 80%;
        }
      }
    }
    .tech-area {
      padding-top: 20px;
      .area-main-title {
        font-size: 28px;
        font-weight: 500;
        margin: 40px 0px 50px;
      }
      .block {
        // margin: 0px 10px;
        margin: 0px;
        .block-img {
          padding: 0px;
          width: 60%;
        }
        .area-sub-title {
          font-size: 12px;
          margin-top: 20px;
        }
      }
      .block-btn {
        padding: 15px 70px;
        margin: 60px 0px 40px;
      }
    }
  }
}
@media screen and (min-width: 992px) and (max-width: 1200px) { // md
  .homePage {
    .block {
      .block-btn {
          padding: 10px 60px;
          border-radius: 5px;
          top: 85%;
          font-size: 12px;
      }
    }
    .about-area {
        padding: 30px 50px ;
        .info {
          .area-main-title {
            font-size: 30px;
            letter-spacing: 2px;
          }
          .area-logo {
            width: 80px;
            margin: 30px 0px;
          }
          .area-sub-title {
            font-size: 20px;
            letter-spacing: 1px;
            margin-bottom: 10px;
          }
          .area-content {
            width: 45%;
          }
        }
        .block-btn {
          padding: 15px 70px;
          border-radius: 6px;
          font-size: 12px;
          margin: 20px 0px;
        }
      }
    .about-area-more {
      background-position: right top;
      padding: 40px 50px ;
      .info {
        .area-sub-title {
          font-size: 20px;
          letter-spacing: 1px;
          margin-bottom: 30px;
        }
        .area-block {
          .area-block-inner {
            display: inline-block;
            width: 90%;
            .area-small-title {
              font-size: 16px;
              margin: 7px 0px;
            }
            .icon {
              width: 70px;
            }
            .area-content {
              width: 100%;
            }
          }
        }
      }
    }
    .dev-area {
      .area-main-title {
        font-size: 35px;
        font-weight: 500;
        margin: 40px 0px 60px;
      }
      .info {
        width: 85%;
        margin-bottom: 60px;
      }
      .block {
        .block-img {
          width: 100%;
        }
        .area-sub-title {
          top: 8%;
          font-size: 14px;
        }
        .area-content {
          font-size: 9px;
          margin-top: 25px;
          top: 8%;
          width: 80%;
        }
      }
      }
  .tech-area {
    padding-top: 20px;
    .area-main-title {
      font-size: 35px;
      font-weight: 500;
      margin: 50px 0px 50px;
    }
    .block {
      margin: 0px 10px;
      .block-img {
        padding: 20px;
        width: 80%;
      }
      .area-sub-title {
        font-size: 16px;
      }
    }
    .block-btn {
      padding: 15px 85px;
      margin: 60px 0px 40px;
    }
  }
  }
}
@media screen and (max-width: 1200px) { // lg
}
/* RWD設定 結束 */
// *--------------------------PC版 結束--------------------------
</style>
<style lang="scss">
/* Modal設定 開始 */
.ivu-modal{
  font-family: 'Noto Sans TC', 'Noto Sans SC', 'Noto Sans', sans-serif;
  .ivu-modal-close .ivu-icon-ios-close {
    font-size: 31px;
    color: #000;
    transition: color .2s ease;
    position: relative;
    font-weight: 800;
    top: 1px;
    &:hover {
      color: #0960d6;
    }
  }
   .ivu-modal-header {
      border-bottom: solid 1px #fff;
      padding: 14px 16px;
      line-height: 1;
      .ivu-modal-header-inner {
        display: inline-block;
        width: 100%;
        height: 20px;
        line-height: 20px;
        font-size: 16px;
        color: #3c4e8c;
        font-weight: 600;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        text-align: center;
    }
  }
  .ivu-modal-footer {
    border-top: solid 1px #fff;
    padding: 12px 18px 12px 18px;
    text-align: right;
  }

}
.icon-email {
  text-align: center;
  margin: 20px 0px;
}
.email {
  text-align: center;
  color: #3c4e8c;
}
.modal-footer {
  display: flex;
  align-items: center;
  justify-content: center;
.copy-btn {
    background-color: #0f1d37;
    color:#fff799;
    border-radius: 5px;
    // width: 50px;
    text-align: center;
    cursor: pointer;
    padding: 10px 40px;
    &:hover {
    background-color: #0960d6;
    color: #f1f1f1;
    }
}
}
.activeBtn {
  background-color: #003c8e !important;
  color: #fff799;
}
</style>
